export const LOAD_MODEL = "LOAD_MODEL";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const UPDATE_STATS = "UPDATE_STATS";
export const COLAPSE_DASH = "COLAPSE_DASH";
//table  constans
export const UPDATE_TABLE = "UPDATE_TABLE";
export const RESET_TABLE = "RESET_TABLE";
export const RESIZE_TABLE = "RESIZE_TABLE";
export const RESET_TABLE_AND_TABS = "RESET_TABLE_AND_TABS";

// user constans
export const DELETE_USER = "DELETE_USER";
export const USER_INFO = "USER_INFO";
export const SIGN_OUT = "SIGN_OUT";
export const STATUS = "STATUS";

// viewer & filters
export const TEMPLATE = "TEMPLATE";
export const CATEGORY = "CATEGORY";
export const SECOND = "SECOND";
export const RESET = "RESET";
export const CLEAR_SETTING_VIEWER = 'CLEAR_SETTING_VIEWER'
export const GET_PARAMETERS_OF_SELECTED_ELEMENTS = 'GET_PARAMETERS_OF_SELECTED_ELEMENTS'
export const CLEAR_PARAMETERS_OF_SELECTED_ELEMENTS_FROM_STATE = "CLEAR_PARAMETERS_OF_SELECTED_ELEMENTS_FROM_STATE"
export const SAVE_SELECTION_OF_VIEWER = "SAVE_SELECTION_OF_VIEWER"

//template
export const ADD_FOLDER = "ADD_FOLDER";
export const ADD_TEMPLATE = "ADD_TEMPLATE";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const RENAME_FOLDER = "RENAME_FOLDER";
export const EDIT_TEMPLATE = "EDIT_TEMPLATE";

//collections
export const GET_FOLDERS_COLLECTIONS = "GET_FOLDERS_COLLECTIONS";
export const SAVE_COLLECTION = "SAVE_COLLECTION";
export const SAVE_COLLECTIONS = "SAVE_COLLECTIONS";
export const CREATE_COLLECTIONS_FOLDER = "CREATE_COLLECTIONS_FOLDER";
export const RENAME_COLLECTIONS_FOLDER = "RENAME_COLLECTIONS_FOLDER";
export const DELETE_COLLECTIONS_FOLDER = "DELETE_COLLECTIONS_FOLDER";
export const EDIT_COLLECTIONS = "EDIT_COLLECTIONS";
export const DELETE_COLLECTIONS = "DELETE_COLLECTIONS";
export const UNASSIGN_FROM_COLLECTIONS = "UNASSIGN_FROM_COLLECTIONS";
export const ADD_TO_NEW_COLLECTION = "ADD_TO_NEW_COLLECTION";
export const COPY_TO_COLLECTION = "COPY_TO_COLLECTION";
export const COPY_TO_COLLECTION_UNSAVED = "COPY_TO_COLLECTION_UNSAVED";
export const ADD_ACTIVE_FOLDER = "ADD_ACTIVE_FOLDER";
export const ASSIGN_TO_COLLECTION = "ASSIGN_TO_COLLECTION";
export const SET_MODE_COMPARE = "SET_MODE_COMPARE";
export const CHANGE_COLLECTION_CHECKBOX = "CHANGE_COLLECTION_CHECKBOX";
export const SET_QUICK_INFO_COMPARE = "SET_QUICK_INFO_COMPARE";


//condition 
export const SET_CONDITION_VARIABLES = "SET_CONDITION_VARIABLES"
export const SET_SHOW_DROPDOWN = "SET_SHOW_DROPDOWN"
export const SET_FUNCTION_VALUE = "SET_FUNCTION_VALUE"
export const SET_COLUMN_NAME_VALUE = "SET_COLUMN_NAME_VALUE"
export const DELETE_COLUMN = "DELETE_COLUMN"
export const SET_CURRENT_SORTED_VALUE = "SET_CURRENT_SORTED_VALUE"
export const SET_CURSOR_POSITION = "SET_CURSOR_POSITION"
export const SET_TREE = "SET_TREE"
export const SET_NODE_LIST = "SET_NODE_LIST"
export const SET_COLUMN_SCHEME = "SET_COLUMN_SCHEME"
export const RESET_CONDITION_MODAL = "RESET_CONDITION_MODAL"

//tabs
export const GET_COLLECTION_TABLE = "GET_COLLECTION_TABLE";
export const CLOSE_TAB = "CLOSE_TAB";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const REPLACE_TAB = "REPLACE_TAB";
export const ADD_SELECT_ITEMS = "ADD_SELECT_ITEMS";
export const SET_CURRENT_TABLE_STATE = "SET_CURRENT_TABLE_STATE";
export const SET_CURRENT_TABLE_CELL = "SET_CURRENT_TABLE_CELL";
export const SET_CURRENT_TABLE_SORT = "SET_CURRENT_TABLE_SORT";
export const SET_TABS_TABLE_STATE = "SET_TABS_TABLE_STATE";

//colorSidebar
export const ADD_COLOR_SETTINGS_ITEM = "ADD_COLOR_SETTINGS_ITEM";
export const UPDATE_SETTINGS_ITEM = "UPDATE_SETTINGS_ITEM";
export const OPEN_COLOR_SIDEBAR = "OPEN_COLOR_SIDEBAR";
export const SET_SIDEBAR_HEADER_OPTIONS = "SET_SIDEBAR_HEADER_OPTIONS";
export const CLOSE_COLOR_SIDEBAR = "CLOS_COLOR_SIDEBAR";
export const REMOVE_COLOR_SETTINGS_ITEM = "REMOVE_COLOR_SETTINGS_ITEM";
export const CLEAR_COLOR_SIDEBAR = "CLEAR_COLOR_SIDEBAR";
export const RESET_COLOR_SIDEBAR = "RESET_COLOR_SIDEBAR";
export const SET_CURRENT_TAB_ID = "SET_CURRENT_TAB_ID";
export const SET_GRADIENT_VALUE = "SET_GRADIENT_VALUE";
export const CREATE_COLOR_SCHEME = "CREATE_COLOR_SCHEME";
export const LOAD_COLOR_SCHEME = "LOAD_COLOR_SCHEME";


//tabsSettings 
export const LOAD_TAB_SETTINGS = "LOAD_TAB_SETTINGS"
export const CLEAR_TEMPORARY_SETTINGS = "CLEAR_TEMPORARY_SETTINGS"
export const CREATE_SETTING_COLOR_SCHEME = "CREATE_SETTING_COLOR_SCHEME";
export const DELETE_SCHEME_SETTING = "DELETE_SCHEME_SETTING";
export const RESET_SCHEME_SETTINGS = "RESET_SCHEME_SETTINGS"

// templateSettings
export const UPDATE_TEMPLATE_SETTINGS = "UPDATE_TEMPLATE_SETTINGS"
export const SET_TEMPLATE_SETTINGS = "SET_TEMPLATE_SETTINGS"
export const SET_COLOR_PRIMARY_COLUMN = "SET_COLOR_PRIMARY_COLUMN";
export const CREATE_SETTING_FILTER_SCHEME = "CREATE_SETTING_FILTER_SCHEME";

//customColumns
export const SET_CUSTOM_PROPERTIES = "SET_CUSTOM_PROPERTIES";
export const DELETE_CUSTOM_PROPERTIES = "DELETE_CUSTOM_PROPERTIES";
export const EDIT_CUSTOM_PROPERTIES = "EDIT_CUSTOM_PROPERTIES";
export const LOAD_CUSTOM_PROPERTIES = "LOAD_CUSTOM_PROPERTIES";


// viewer model translations
export const ADD_TRANSLATIONS = "ADD_TRANSLATIONS";
export const RESET_TRANSLATIONS = "RESET_TRANSLATIONS";